import { isBoolean, isEmpty } from "lodash";
import React, { isValidElement } from "react";
import { useTranslation } from "react-i18next";

const ProductTags = ({
    tags,
    emptyMessage,
    emptyElement,
    center,
    removeTagHandler,
    isColumn,
    limit = null,
    keyName = "label",
    listClassName = "",
}) => {
    const { t } = useTranslation();

    const getEmptyContent = () => {
        if (emptyElement) {
            return emptyElement();
        } else {
            return <p>{emptyMessage || "--"}</p>;
        }
    };

    const getTagContent = (tag) => {
        const content = tag[keyName] ?? tag;

        if (isBoolean(content)) return `${content}`;

        return content;
    };

    const renderTags = () => {
        const cappedTags = limit ? tags.slice(0, limit) : tags;
        return isEmpty(tags)
            ? getEmptyContent()
            : cappedTags.map((tag, index) => {
                  if (
                      !tag ||
                      (typeof tag[keyName] === "object" &&
                          !isValidElement(tag[keyName]))
                  )
                      return;
                  return (
                      <li
                          key={tag?.index || index}
                          className={`tags-items ${listClassName}`}
                      >
                          {tag.tagTitle && (
                              <span className="font-semibold mr-1">
                                  {tag.tagTitle}:
                              </span>
                          )}
                          {getTagContent(tag)}

                          {tag.hidden && (
                              <span className="text-xxxs ml-0.5 opacity-80">
                                  {`(${t("hidden")?.toLowerCase()})`}
                              </span>
                          )}

                          {removeTagHandler && (
                              <i
                                  onClick={() =>
                                      removeTagHandler(
                                          tag[keyName] || tag,
                                          tag?.index || index
                                      )
                                  }
                                  className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                              />
                          )}
                      </li>
                  );
              });
    };
    return (
        <>
            <ul
                className={`tags-wrapper flex flex-wrap ${
                    isColumn
                        ? "flex-col content-start justify-start items-start"
                        : ""
                } ${center ? "justify-center items-center" : ""}`}
            >
                {renderTags()}
                {limit && limit < tags.length && (
                    <li>
                        <p>...</p>
                    </li>
                )}
            </ul>
        </>
    );
};

export default ProductTags;
